import type { SimpleProject } from '../../types';

import { cache } from '../cache';
import { estClient } from './estClient';

class ProjectApi {
  getAll(): Promise<SimpleProject[]> {
    return cache.get('projects', () =>
      estClient.get<SimpleProject[]>('/api/object/all'),
    );
  }
}

export const projectApi = new ProjectApi();
